// Copyright (c) 2016 Deere & Company

import './alert-bar-container.scss';
import React, {PropTypes} from 'react';
import AlertMessage from '../../state/alert-message';
import {ErrorMessageContainer} from './error-message-container';
import {InfoMessageContainer} from './info-message-container';
import NotificationAreaContainer from '../alert-bar/notification-area-container';
import {SuccessMessageContainer} from './success-message-container';
import {WarningMessageContainer} from './warning-message-container';

export const AlertBarContainer = props => {

    const errorBar = props.errorMessages.length > 0 &&
        <ErrorMessageContainer
            errorMessages={props.errorMessages}
            onDismiss={props.onDismiss}
        />;

    const infoBar = props.infoMessages.length > 0 &&
        <InfoMessageContainer
            infoMessages={props.infoMessages}
            onDismiss={props.onDismiss}
        />;

    const successBar = props.successMessages.length > 0 &&
        <SuccessMessageContainer
            onDismiss={props.onDismiss}
            successMessages={props.successMessages}
        />;

    const warningBar = props.warningMessages.length > 0 &&
        <WarningMessageContainer
            onDismiss={props.onDismiss}
            warningMessages={props.warningMessages}
        />;

    return (
        <div className='alert-bar-container cap-it-ui-alert-bar'>
            <NotificationAreaContainer>
                {warningBar}
                {infoBar}
                {successBar}
                {errorBar}
            </NotificationAreaContainer>
        </div>
    );

};

AlertBarContainer.displayName = 'AlertBarContainer';

AlertBarContainer.propTypes = {
    errorMessages: PropTypes.arrayOf(
        PropTypes.instanceOf(AlertMessage)
    ).isRequired,
    infoMessages: PropTypes.arrayOf(
        PropTypes.instanceOf(AlertMessage)
    ).isRequired,
    onDismiss: PropTypes.func.isRequired,
    successMessages: PropTypes.arrayOf(
        PropTypes.instanceOf(AlertMessage)
    ).isRequired,
    warningMessages: PropTypes.arrayOf(
        PropTypes.instanceOf(AlertMessage)
    ).isRequired
};



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar-container/index.js